/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useState, useEffect, useRef } from 'react';
import MainHeader from "../../../../Shared/components/Header";
import PurchaseIcon from "../../../../../assets/images/icon_menus/PurchaseIcon.json";
import customStyles from "../../../../../assets/styles/customStyles";
import clsx from 'clsx';
import PrimaryCard from "../../../../Shared/components/Card/PrimaryCard";
import { Row, Col, Image, Space } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { checkViewPermission, checkCRUDPermission, checkComponentPermission, idNamingConversion } from '../../../../../helpers/utilities';
import { TextField } from "@mui/material";
import usePrevious from "../../../../Shared/components/Previous";
import SearchIcon from "../../../../../assets/images/icon_actions/Search Icon.svg";
import { Link, NavLink } from "react-router-dom";
import ClearIcon from "../../../../../assets/images/icon_actions/Clear Icon.svg";
import AddIcon from "../../../../../assets/images/icon_actions/Add Icon.svg";
import crudActions from "../../../../CRUD/redux/actions";
import { ListTable } from "./ListTable";
import { useEventListener } from "../../../../../helpers/useEventListener";


export default function PurchaseOrder(props) {
    const { roleManagement } = useSelector(state => state.authReducer);
    const { getList, getData } = useSelector(state => state.crudReducer);
    const { businessDetails } = useSelector(state => state.homeReducer);
    const dispatch = useDispatch();
    const [search, setSearch] = useState('');
    const [iconAnimation, setIconAnimation] = useState(false);
    const prevSearch = usePrevious(search);
    const [skip, setSkip] = useState(0);
    const timeoutRef = useRef(null);
    const { history } = props;
    const limit = 25;
    const [sortOrder, setSortOrder] = useState("desc");
    const [sortBy, setSortBy] = useState("serialNo");
    const [loadMore, setLoadMore] = useState(false);
    const [loadMoreContent, setLoadMoreContent] = useState(false);

    useEffect(() => {
        if ((prevSearch !== undefined && search && search.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (search === '') {
                dispatchFilter(sortBy, sortOrder);
            } else {
                timeoutRef.current = setTimeout(() => {
                    timeoutRef.current = null;
                    dispatchFilter(sortBy, sortOrder);
                }, 500);
            }
        }
    }, [search]);

    useEffect(() => {
        if (roleManagement !== '') {
            if (checkViewPermission('Purchase Order', history, 'Purchase')) {
                dispatchFilter(sortBy, sortOrder);
            }
        }
    }, [roleManagement]);

    const prevGetData = usePrevious(getData);
    useEffect(() => {
        if (loadMore && getData === '') {
            setLoadMoreContent(false);
            setLoadMore(true);
        }

        if (prevGetData !== undefined && getData && prevGetData !== getData) {
            const timer = setTimeout(() => {
                if (getData && Array.isArray(getData) && getData.length > 0) {
                    setLoadMore(true);
                    if (getData.length < limit) {
                        setLoadMoreContent(false);
                    } else {
                        setLoadMoreContent(true);
                    }
                } else {
                    setLoadMoreContent(false);
                    setLoadMore(true);
                }
            });

            return () => {
                clearTimeout(timer);
            };
        }
    }, [getData]);

    const requestSort = (sortBy, sortOrder) => {
        setSortBy(sortBy);
        setSortOrder(sortOrder);
        dispatchFilter(sortBy, sortOrder);
    }


    const handleKeyDown = (e) => {
        if ((e.altKey && e.keyCode === 78) || (navigator.platform.match("Mac") && e.ctrlKey && e.keyCode === 78)) { ///ALT +N
            e.preventDefault();
            history.push('/purchase/purchase-management/purchase-order/create');
        }
    };

    useEventListener("keydown", handleKeyDown);

    const dispatchFilter = (sortBy, sortOrder, skip = 0) => {
        if (skip === 0) {
            setLoadMore(false);
            setLoadMoreContent(false);
        }
        let filter = { ["or"]: [] };

        if (search !== '') {
            filter['or'].push({ serialNo: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ OrderStatus: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ invoiceAmount: parseFloat(search.trim()) });
            filter['or'].push({ phone: search.trim() });
        }

        setSkip(skip);
        dispatch({
            type: crudActions.GET_DETAILS_START,
            url: 'v1/sales-order/purchase-orders',
            skip: skip,
            filter: {
                where: filter,
                order: sortBy + ' ' + sortOrder,
                limit: limit,
                skip: skip,
            }
        });
    }

    const loadMoreTask = () => {
        let s = skip + limit;
        dispatchFilter(sortBy, sortOrder, s);
    }

    const classes = customStyles();
    return (
        <Fragment>
            <MainHeader {...props}
                closeLink={'/purchase'}
                cls={'newImg'} img={PurchaseIcon} title={'Purchase'} links={[{ 'label': 'Purchase', 'link': '/purchase' }, { 'label': 'Purchase Order', 'link': '' }]} />
            <div className={clsx(classes.margin40, classes.listTableMargin)}>
                <PrimaryCard
                    title={'Purchase Order'}
                    component={
                        <>
                            <Row align="middle" className={classes.marginBottom20}>
                                <Col xxl={6} xl={7} lg={8} md={10} sm={14} xs={24}>
                                    {
                                        roleManagement !== '' && checkComponentPermission('Purchase Order', 'Action', 'Search') &&
                                        <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation || search !== '' })}>
                                            <TextField autoComplete='one-time-code'
                                                placeholder='Search PO No., Ph Number, Amount, and Status'
                                                type='search'
                                                value={search}
                                                onChange={(e) => setSearch(e.target.value)}
                                                className={classes.comInput}
                                                variant={'standard'}
                                                fullWidth
                                                onFocus={() => setIconAnimation(true)}
                                                onBlur={() => setIconAnimation(false)}
                                                id={idNamingConversion('Search', 'purchaseOrder', 'TextField')}
                                            />
                                            <Image src={SearchIcon} preview={false} />
                                            {
                                                search && <NavLink to="#" onClick={() => setSearch('')} className={classes.searchClear}>
                                                    <Image
                                                        src={ClearIcon}
                                                        preview={false}
                                                    />
                                                </NavLink>
                                            }
                                        </div>
                                    }
                                </Col>
                                <Col xxl={18} xl={17} lg={16} md={14} sm={10} xs={24}
                                    className={clsx(classes.textAlignRight, classes.vertiCalScrollOverFlowParent, classes.removeUnderline, classes.customerLabelNone)}>
                                    <div className={classes.vertiCalScrollOverFlow}>
                                        <Space size={[20, 20]} direction="horizontal" align="center">
                                            {
                                                roleManagement !== '' && checkCRUDPermission('Purchase Order', 'create', 'Purchase') &&
                                                <Link
                                                    id={idNamingConversion('Create Purchase Order', 'purchaseOrder', 'Link')}
                                                    to={'/purchase/purchase-management/purchase-order/create'}
                                                    // onClick={() => handleOpen()}
                                                    className={clsx(classes.customLink)}>
                                                    <Image src={AddIcon} preview={false} className={clsx(classes.antImage)}
                                                    /><span className={clsx(classes.addLink, classes.color, classes.bold)}>Create Purchase Order</span>
                                                </Link>
                                            }
                                        </Space>
                                    </div>
                                </Col>
                            </Row>
                            <ListTable
                                search={search}
                                businessDetails={businessDetails}
                                loadTasks={() => dispatchFilter(sortBy, sortOrder)}
                                details={getList}
                                loadMore={loadMore}
                                loadMoreContent={loadMoreContent}
                                loadMoreTask={() => loadMoreTask()}
                                sortOrder={sortOrder} sortBy={sortBy}
                                roleManagement={roleManagement}
                                onRequestSort={(sortBy, sortOrder) => requestSort(sortBy, sortOrder)} />
                        </>
                    }
                />
            </div>
        </Fragment>
    )
}